import { View, ViewProps } from "react-native"
import { cn } from "@src/utils"
import { Text } from "./typography"

type BadgeVariant = "default" | "secondary" | "destructive" | "outline" | "success" | "warning"

interface BadgeProps extends ViewProps {
  variant?: BadgeVariant
  className?: string
  children: React.ReactNode
}

export function Badge({ className, variant = "default", children, ...props }: BadgeProps) {
  const variants: Record<BadgeVariant, string> = {
    default: "border-transparent bg-blue-600",
    secondary: "border-transparent bg-gray-100",
    destructive: "border-transparent bg-red-500",
    outline: "border-gray-200",
    success: "border-transparent bg-green-600",
    warning: "border-transparent bg-yellow-500",
  }

  const textVariants: Record<BadgeVariant, string> = {
    default: "text-white",
    secondary: "text-gray-900",
    destructive: "text-white",
    outline: "text-gray-900",
    success: "text-white",
    warning: "text-white",
  }

  const containerClass = cn("items-center rounded-full border px-2.5 py-0.5", variants[variant], className)

  const textClass = cn("text-xs font-semibold", textVariants[variant])

  return (
    <View className={containerClass} {...props}>
      {typeof children === "string" ? (
        <Text className={textClass} variant="small">
          {children}
        </Text>
      ) : (
        children
      )}
    </View>
  )
}
